<template>
  <Header />
  <!-- <BreadCrumb :valueFromParent="parentValue" /> -->
  <BreadCrumb
  title="Privacy Policy"        
        :breadcrumbs="[{ text: 'Privacy Policy', to: '/privacy-policy' }]"
  />
  <PrivacyPolicy/>
  <Newsletter />
  <Footer />
</template>

<script setup>
import PrivacyPolicy from "@/components/PrivacyPolicy.vue";
import Newsletter from "@/components/NewsletterBox.vue";
import Header from "@/components/Header.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import Footer from "@/components/FooterArea.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { ref, onMounted } from 'vue';
// export default {
//   name: "Privacy Policy",
//   components: {
//     Header,
//     BreadCrumb,
//     Newsletter,
//     Footer,
//   },
//   setup() {
//     // Define a reactive variable to hold the title
//     const pageTitle = ref('Salt - Privacy Policy');

//     // Function to update the title
//     const updateTitle = () => {
//       document.title = pageTitle.value;
//     };

//     // Call updateTitle when component is mounted
//     onMounted(() => {
//       updateTitle();
//     });

//     return {
//       pageTitle,
//       updateTitle
//     };
//   }

// };
</script>

<style scoped>
.aboutus {
  padding: 70px 0 0 0;
}
.textStyle {
  text-align: left;
}
.aboutus img {
  max-width: 100%;
}
.aboutus h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
